import { getFlightItemPolicyEvaluationCostFromView } from 'checkout/lib/utils/flights/getFlightItemViewPrice'
import type { CartEvaluationItemInputWire, CartEvaluationItemTravellerInputWire } from 'businessTraveller/api/requestPostCartEvaluation'
import type { FlightDateChangeOrderTraveller } from 'businessTraveller/selectors/selectFlightDateChangeOrderTravellers'

type BuildFlightDateChangeCartEvaluationItemsParams = {
  flightItemsViews: App.WithDataStatus<Array<App.Checkout.FlightItemView>>
  currencyCode: string
  /** The booked order item travellers */
  orderTravellers: Array<Pick<FlightDateChangeOrderTraveller, 'employeeId' | 'isPrimaryTraveller'>>
}

export function buildFlightDateChangeCartEvaluationItems(
  params: BuildFlightDateChangeCartEvaluationItemsParams,
): Array<CartEvaluationItemInputWire> {
  const { flightItemsViews, currencyCode, orderTravellers } = params

  if (!flightItemsViews.hasRequiredData || orderTravellers.length === 0) {
    return []
  }

  const travellers: Array<CartEvaluationItemTravellerInputWire> = orderTravellers.map((traveller) => ({
    employeeId: traveller.employeeId,
    isPrimaryTraveller: traveller.isPrimaryTraveller,
  }))

  return flightItemsViews.data.map((flightItemView) => ({
    transactionKey: `${flightItemView.item.transactionKey}--date-change`,
    cartItemId: flightItemView.item.itemId,
    // A zero cost change still evaluates, so an ALWAYS approval policy applies
    cost: getFlightItemPolicyEvaluationCostFromView(flightItemView),
    travellers,
    itemPolicyLookup: {
      itemPolicyType: 'FLIGHT_DATE_CHANGE',
      currencyCode,
      // oneWay = one leg changed, return = both legs changed; carried on the cart item
      // because checkout initialise resets the flights date change state.
      flightViewType: flightItemView.item.dateChangeLegCount === 2 ? 'return' : 'oneWay',
      travellerCount: orderTravellers.length,
    },
  }))
}
